/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ReferencePropertyWithResolved } from '../models/reference-property-with-resolved';

@Injectable({ providedIn: 'root' })
export class GroupsControllerService extends DataBaseService {

  /**
   * Path part for operation groupsControllerGetUsersInsideGroup
   */
  static readonly GroupsControllerGetUsersInsideGroupPath = '/v1/group/{groupId}/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsersInsideGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersInsideGroup$Response(params: {
    groupId: string;
    includeResolved?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<ReferencePropertyWithResolved>>> {

    const rb = new RequestBuilder(this.rootUrl, GroupsControllerService.GroupsControllerGetUsersInsideGroupPath, 'get');
    if (params) {
      rb.path('groupId', params.groupId, {});
      rb.query('includeResolved', params.includeResolved, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ReferencePropertyWithResolved>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUsersInsideGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersInsideGroup(params: {
    groupId: string;
    includeResolved?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<ReferencePropertyWithResolved>> {

    return this.getUsersInsideGroup$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ReferencePropertyWithResolved>>) => r.body as Array<ReferencePropertyWithResolved>)
    );
  }

}
